<div class="shortcut-container">
  <h3 class="shortcut-title">Danh sách phím tắt trên phần mềm</h3>
  <table class="table table-bordered shortcut-table">
    <thead>
        <tr>
          <th>Phím chung</th>
          <th>Danh sách thư mục</th>
          <th>Danh sách tài liệu</th>
          <th>Kiểm tra tài liệu số hóa</th>
          <th>Màn hình nhập liệu</th>
        </tr>
    </thead>
    <tbody>
        <tr>
          <td>
            <div class="shortcut-item"><span>Hiển thị phím tắt</span><span class="key">`</span></div>
            <div class="shortcut-item"><span>Mở toàn màn hình</span><span class="key">F11</span></div>
          </td>
  
          <td>
            <div class="shortcut-item">
              <span>Phân quyền</span>
              <div>
                <span class="key">Ctrl</span><span class="key">F1</span>
              </div>
            </div>
            <div class="shortcut-item"><span>Nhận dạng</span><span class="key">F2</span></div>
            <div class="shortcut-item"><span>Đồng bộ</span><span class="key">F3</span></div>
            <div class="shortcut-item"><span>Tính toán lại</span><span class="key">F4</span></div>
            <div class="shortcut-item"><span>Thêm thư mục</span><span class="key">F6</span></div>
            <div class="shortcut-item"><span>Đóng thư mục</span><span class="key">F7</span></div>
            <div class="shortcut-item"><span>Mở thư mục</span><span class="key">F8</span></div>
            <div class="shortcut-item"><span>Xuất excel</span><span class="key">F9</span></div>
            <div class="shortcut-item"><span>Kiểm tra tài liệu</span><span class="key">F10</span></div>
            <div class="shortcut-item"><span>Tìm kiếm thư mục</span><span class="key">/</span></div>
          </td>
  
          <td>
            <div class="shortcut-item"><span>Thay thế</span>
              <div>
                <span class="key">Ctrl</span><span class="key">F1</span>
              </div>
            </div>
            <div class="shortcut-item"><span>Tải lên</span><span class="key">F2</span></div>
            <div class="shortcut-item"><span>Nhận dạng</span><span class="key">F3</span></div>
            <!-- <div class="shortcut-item"><span>In mục lục</span><span class="key">F4</span></div> -->
            <div class="shortcut-item"><span>Sắp xếp lại tài liệu</span><span class="key">F6</span></div>
            <div class="shortcut-item"><span>Xuất excel</span><span class="key">F7</span></div>
            <div class="shortcut-item"><span>Xóa</span><span class="key">F8</span></div>
            <div class="shortcut-item"><span>Kiểm tra</span><span class="key">F10</span></div>
            <div class="shortcut-item"><span>Quay lại</span><span class="key">Esc</span></div>
          </td>
  
          <td>
            <div class="shortcut-item"><span>Thay thế</span>
              <div>
                <span class="key">Ctrl</span><span class="key">F1</span>
              </div>
            </div>
            <div class="shortcut-item"><span>Đóng thư mục</span><span class="key">F2</span></div>
            <div class="shortcut-item"><span>Mở thư mục</span><span class="key">F3</span></div>
            <div class="shortcut-item"><span>Nhận dạng</span><span class="key">F4</span></div>
            <div class="shortcut-item"><span>Xuất excel</span><span class="key">F6</span></div>
            <div class="shortcut-item"><span>Xuất excel tất cả</span><span class="key">F7</span></div>
            <div class="shortcut-item"><span>Tìm kiếm thư mục</span><span class="key">/</span></div>
            <div class="shortcut-item"><span>Quay lại</span><span class="key">Esc</span></div>
          </td>
  
          <td>
            <div class="shortcut-item"><span>Thay thế tài liệu</span>
              <div>
                <span class="key">Ctrl</span><span class="key">F1</span>
              </div>
            </div>
            <div class="shortcut-item"><span>Nhận dạng lại</span><span class="key">F2</span></div>
            <div class="shortcut-item"><span>Mở mục lục</span><span class="key">F3</span></div>
            <div class="shortcut-item"><span>Xoay tài liệu</span><span class="key">F4</span></div>
            <div class="shortcut-item">
              <span>Phóng to tài liệu</span>
              <div>
                <span class="key">shift</span><span class="key">+</span>
              </div>
            </div>
            <div class="shortcut-item">
              <span>Phóng nhỏ tài liệu</span>
              <div>
                <span class="key">shift</span><span class="key">-</span>
              </div>
            </div>
            <div class="shortcut-item"><span>Ẩn/Hiện dữ liệu chuẩn hóa</span><span class="key">F6</span></div>
            <div class="shortcut-item"><span>Lưu và kế tiếp</span><span class="key">→</span></div>
            <div class="shortcut-item"><span>Tài liệu trước</span><span class="key">←</span></div>
            <div class="shortcut-item"><span>Chuyển ô nhập liệu</span><span class="key">Tab</span></div>
            <div class="shortcut-item"><span>Quay lại</span><span class="key">Esc</span></div>
          </td>
        </tr>
    </tbody>
  </table>

  <div class="shortcut-note">
    <strong>Một số tính năng hỗ trợ nhập liệu:</strong>
    <ul>
      <li>Khi nhập liệu có thể thực hiện scan trực tiếp lên tài liệu bằng cách click icon <i class="ti ti-scan"></i></li>
      <li>Khi click vào ô nhập liệu hệ thống sẽ tự động kéo đến vị trí trang được nhận dạng.</li>
    </ul>
  </div>
</div>

<style>
  .shortcut-item {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    padding: 2px 0;
  }

  .key {
    font-weight: bold;
    background: #000;
    border-radius: 4px;
    padding: 2px 6px;
    min-width: 40px;
    text-align: center;
    display: inline-block;
    border: 1px solid #ccc;
  }

  table.shortcut-table td {
    vertical-align: top;
    padding: 10px;
  }

</style>